import { render, staticRenderFns } from "./UserInitConfirmSection.vue?vue&type=template&id=2622ac6a&scoped=true"
import script from "./UserInitConfirmSection.vue?vue&type=script&lang=ts"
export * from "./UserInitConfirmSection.vue?vue&type=script&lang=ts"
import style0 from "./UserInitConfirmSection.vue?vue&type=style&index=0&id=2622ac6a&prod&lang=scss&scoped=true"
import style1 from "./UserInitConfirmSection.vue?vue&type=style&index=1&id=2622ac6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2622ac6a",
  null
  
)

export default component.exports